import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/pro-regular-svg-icons/faImages";
import { Gallery } from "components/Editor/Gallery";

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faImages} size="6x" />
    </div>
);

const CarouselComponent = ({ state: { images = [] } }) => {
    const inStorefront = !window?.location?.pathname.includes("/content/edit/");

    return (
        <>
            {images?.length > 0 ? (
                <Gallery images={images.map((image) => image.url)} />
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    );
};

export default CarouselComponent;
